import { configureStore } from '@reduxjs/toolkit';
import { api } from '../graphql/graphql';
import { mzcrApi } from '../Modules/Mzcr/Services/mzcrApi';
import { setupListeners } from '@reduxjs/toolkit/query';
import userReducer from './reducers/userSlice';
import aclReducer from './reducers/aclSlice';
import patientMetaReducer from './reducers/patientMetaSlice';
import patientConsetReducer from './reducers/patientConsetSlice';
import workplaceTermItemsSliceReducer from './reducers/workplaceTermItemsSlice';
import ncziReducer from './reducers/ncziSlice';

import {
	persistReducer,
	persistStore,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const aclPersistConfig = {
	key: 'acl',
	storage,
	whitelist: ['isLoaded', 'tree', 'loadedAt'],
};

const persistedAclReducer = persistReducer(aclPersistConfig, aclReducer);

export const store = configureStore({
	reducer: {
		[api.reducerPath]: api.reducer,
		[mzcrApi.reducerPath]: mzcrApi.reducer,
		acl: persistedAclReducer,
		user: userReducer,
		patientMeta: patientMetaReducer,
		patientConsent: patientConsetReducer,
		workplaceTermItems: workplaceTermItemsSliceReducer,
		nczi: ncziReducer,
	},
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}).concat(api.middleware, mzcrApi.middleware),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
